var NavigationAction = /*#__PURE__*/ function(NavigationAction) {
    NavigationAction["BACK"] = "BACK";
    NavigationAction["FORWARD"] = "FORWARD";
    return NavigationAction;
}(NavigationAction || {});
var ProcessRunType = /*#__PURE__*/ function(ProcessRunType) {
    ProcessRunType["MANUAL"] = "MANUAL";
    ProcessRunType["PREDICTION"] = "PREDICTION";
    ProcessRunType["SOURCE"] = "SOURCE";
    ProcessRunType["CQA"] = "CQA";
    return ProcessRunType;
}(ProcessRunType || {});
var EntriesMessageType = /*#__PURE__*/ function(EntriesMessageType) {
    EntriesMessageType["ADT"] = "Registration";
    EntriesMessageType["SIU"] = "Surgery";
    EntriesMessageType["ORM"] = "Orders";
    EntriesMessageType["RDS"] = "Medication";
    EntriesMessageType["MDM"] = "Notes";
    EntriesMessageType["DFT"] = "Charges";
    return EntriesMessageType;
}(EntriesMessageType || {});
var CodeChangeType = /*#__PURE__*/ function(CodeChangeType) {
    CodeChangeType["UPDATE"] = "UPDATE";
    CodeChangeType["ADD"] = "ADD";
    CodeChangeType["DELETE"] = "DELETE";
    CodeChangeType["SEARCH_DROP"] = "SEARCH_DROP";
    return CodeChangeType;
}(CodeChangeType || {});
var ProcessStatus = /*#__PURE__*/ function(ProcessStatus) {
    ProcessStatus["PROCESS_CREATED"] = "Process Created";
    ProcessStatus["WAITING_FOR_DATA"] = "Waiting for data";
    ProcessStatus["DATA_COLLECTED"] = "Data Collected";
    ProcessStatus["PREDICTION_IN_PROGRESS"] = "Prediction in Progress";
    ProcessStatus["PREDICTED"] = "Predicted";
    ProcessStatus["MANUAL"] = "Manual";
    ProcessStatus["AT_CODER"] = "At Coder";
    ProcessStatus["DONE"] = "Done";
    ProcessStatus["ERROR"] = "Error";
    return ProcessStatus;
}(ProcessStatus || {});
var AccelerateProcessStatus = /*#__PURE__*/ function(AccelerateProcessStatus) {
    /*
  Pre-coder states
  */ AccelerateProcessStatus["WAITING_FOR_IMPORT"] = "WAITING_FOR_IMPORT";
    AccelerateProcessStatus["IMPORTING"] = "IMPORTING";
    AccelerateProcessStatus["RETRY_IMPORT"] = "RETRY_IMPORT";
    /*
  Coder states
   */ AccelerateProcessStatus["NEW"] = "NEW";
    AccelerateProcessStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AccelerateProcessStatus["SUBMITTED"] = "SUBMITTED";
    /*
  Post-coder states
   */ AccelerateProcessStatus["WAITING_FOR_SEND"] = "WAITING_FOR_SEND";
    AccelerateProcessStatus["SENDING"] = "SENDING";
    AccelerateProcessStatus["SENT"] = "SENT";
    AccelerateProcessStatus["RETRY_SEND"] = "RETRY_SEND";
    AccelerateProcessStatus["LATE_CASE_UPDATE"] = "LATE_CASE_UPDATE";
    /*
  Canceled and Replaced state
   */ AccelerateProcessStatus["CANCELLED"] = "CANCELLED";
    AccelerateProcessStatus["REPLACED"] = "REPLACED";
    AccelerateProcessStatus["REPLACED_CANCELLED"] = "REPLACED_CANCELLED";
    AccelerateProcessStatus["REMOVED"] = "REMOVED";
    return AccelerateProcessStatus;
}(AccelerateProcessStatus || {});
var ProcessQAStatus = /*#__PURE__*/ function(ProcessQAStatus) {
    ProcessQAStatus["IN_QA"] = "IN_QA";
    ProcessQAStatus["QA_COMPLETE"] = "QA_COMPLETE";
    return ProcessQAStatus;
}(ProcessQAStatus || {});
var CaseStatus = /*#__PURE__*/ function(CaseStatus) {
    CaseStatus["DORMANT"] = "Dormant";
    CaseStatus["DONE"] = "Done";
    CaseStatus["CASE_CREATED"] = "Case Created";
    CaseStatus["IN_PROCESS"] = "In Process";
    CaseStatus["DATA_COLLECTED"] = "Data Collected";
    CaseStatus["CANCELLED"] = "Cancelled";
    CaseStatus["DID_NOT_CODE"] = "Did not code";
    return CaseStatus;
}(CaseStatus || {});
var CodeType = /*#__PURE__*/ function(CodeType) {
    CodeType["DIAGNOSIS"] = "diagnosis";
    CodeType["PROCEDURE"] = "procedure";
    CodeType["TECHNICAL_CHARGE"] = "TECHNICAL";
    CodeType["CPT"] = "CPT";
    CodeType["ICD"] = "ICD";
    CodeType["MODIFIER"] = "MODIFIER";
    return CodeType;
}(CodeType || {});
var EvidenceType = /*#__PURE__*/ function(EvidenceType) {
    EvidenceType["MAPPED"] = "mapping";
    EvidenceType["PARTIAL"] = "partial";
    EvidenceType["COMPLETE"] = "complete";
    return EvidenceType;
}(EvidenceType || {});
var EditorIssueLevel = /*#__PURE__*/ function(EditorIssueLevel) {
    EditorIssueLevel["WARNING"] = "WARNING";
    EditorIssueLevel["ERROR"] = "ERROR";
    EditorIssueLevel["UNKNOWN"] = "UNKNOWN";
    return EditorIssueLevel;
}(EditorIssueLevel || {});
var EditorIssueProvenance = /*#__PURE__*/ function(EditorIssueProvenance) {
    EditorIssueProvenance["CCI"] = "CCI";
    EditorIssueProvenance["CLAIMS"] = "CLAIMS";
    EditorIssueProvenance["CUSTOM_RULES"] = "CUSTOM_RULES";
    return EditorIssueProvenance;
}(EditorIssueProvenance || {});
var Gen2CaseStatus = /*#__PURE__*/ function(Gen2CaseStatus) {
    Gen2CaseStatus["CREATED"] = "Created";
    Gen2CaseStatus["IN_PROGRESS"] = "In Progress";
    Gen2CaseStatus["CANCELLED"] = "Cancelled";
    Gen2CaseStatus["MANUAL"] = "Manual";
    Gen2CaseStatus["AUTOMATED"] = "Automated";
    Gen2CaseStatus["UPDATED_MANUAL"] = "Updated - Manual";
    Gen2CaseStatus["DORMANT"] = "Dormant";
    Gen2CaseStatus["CLOSED_NEW_VERSION"] = "Closed - New Version";
    return Gen2CaseStatus;
}(Gen2CaseStatus || {});
var Gen2ProcessStatus = /*#__PURE__*/ function(Gen2ProcessStatus) {
    Gen2ProcessStatus["PROCESS_CREATED"] = "Process Created";
    Gen2ProcessStatus["IN_PROGRESS"] = "In Progress";
    Gen2ProcessStatus["DATA_AGGREGATION"] = "Data Aggregation";
    Gen2ProcessStatus["RESULTS_HOLD"] = "Results Hold";
    Gen2ProcessStatus["WAITING_FOR_DATA"] = "Waiting for Data";
    Gen2ProcessStatus["DATA_COLLECTED"] = "Data Collected";
    Gen2ProcessStatus["PREDICTED"] = "Predicted";
    Gen2ProcessStatus["PREDICTION_FAILED"] = "Prediction Failed";
    Gen2ProcessStatus["SENDING_TO_CODER"] = "Sending To Coder";
    Gen2ProcessStatus["AT_CODER"] = "At Coder";
    Gen2ProcessStatus["CODES_RECEIVED"] = "Codes Received";
    Gen2ProcessStatus["NO_FEEDBACK"] = "No Feedback";
    Gen2ProcessStatus["ADDED_TO_GROUP"] = "Added to Group";
    Gen2ProcessStatus["READY_TO_SUBMIT_GROUP"] = "Ready to Submit Group";
    Gen2ProcessStatus["BILLING_HOLD"] = "Billing Hold";
    Gen2ProcessStatus["READY_TO_EXPORT"] = "Ready to Export";
    Gen2ProcessStatus["BILLING_EXPORT_HOLD"] = "Billing Export Hold";
    Gen2ProcessStatus["TERMINATED"] = "Terminated";
    Gen2ProcessStatus["DONE"] = "Done";
    Gen2ProcessStatus["EXPIRED"] = "Expired";
    Gen2ProcessStatus["ERROR"] = "Error";
    return Gen2ProcessStatus;
}(Gen2ProcessStatus || {});
var uiStatus = /*#__PURE__*/ function(uiStatus) {
    uiStatus["IN_PROGRESS"] = "In Progress";
    uiStatus["IN_PROCESS"] = "In Process";
    uiStatus["WAITING"] = "Waiting For Coder";
    uiStatus["MANUAL"] = "Manual";
    uiStatus["DORMANT"] = "Dormant";
    uiStatus["CANCELLED"] = "Cancelled";
    uiStatus["AUTOMATED"] = "Automated";
    uiStatus["UPDATED_MANUAL"] = "Updated - Manual";
    uiStatus["CLOSED_NON_CHARGEABLE"] = "Closed Non-chargeable";
    return uiStatus;
}(uiStatus || {});
var CaseDataTypes = /*#__PURE__*/ function(CaseDataTypes) {
    CaseDataTypes["DATE"] = "DATE";
    CaseDataTypes["BOOLEAN"] = "BOOLEAN";
    CaseDataTypes["IDENTIFIER_ISSUER"] = "IDENTIFIER_ISSUER";
    CaseDataTypes["IDENTIFIER_NUMBER"] = "IDENTIFIER_NUMBER";
    return CaseDataTypes;
}(CaseDataTypes || {});
var CaseDataGroup = /*#__PURE__*/ function(CaseDataGroup) {
    CaseDataGroup["PATIENT"] = "patient";
    CaseDataGroup["ORGANIZATION"] = "organization";
    CaseDataGroup["ENCOUNTER"] = "encounter";
    CaseDataGroup["ORDER"] = "order";
    CaseDataGroup["BILLING"] = "billing";
    CaseDataGroup["CMX"] = "cmx";
    return CaseDataGroup;
}(CaseDataGroup || {});
var IdentifierType = /*#__PURE__*/ function(IdentifierType) {
    IdentifierType["MRN"] = "MRN";
    IdentifierType["VISIT_NUMBER"] = "VISIT_NUMBER";
    IdentifierType["APPOINTMENT_NUMBER"] = "APPOINTMENT_NUMBER";
    return IdentifierType;
}(IdentifierType || {});
var SystemRole = /*#__PURE__*/ function(SystemRole) {
    SystemRole["ADMIN"] = "admin";
    SystemRole["SUPER_ADMIN"] = "super_admin";
    SystemRole["COORDINATOR"] = "coordinator";
    SystemRole["CODER"] = "coder";
    SystemRole["DEMO"] = "demo";
    SystemRole["USER_MANAGER"] = "user_manager";
    SystemRole["EXTERNAL_SYSTEM"] = "external_system";
    SystemRole["SYSTEM"] = "system";
    return SystemRole;
}(SystemRole || {});
var ResourceTypes = /*#__PURE__*/ function(ResourceTypes) {
    ResourceTypes["UI"] = "ui";
    return ResourceTypes;
}(ResourceTypes || {});
var TaskTypes = /*#__PURE__*/ function(TaskTypes) {
    TaskTypes["BUSINESS_RULE"] = "businessRuleTask";
    TaskTypes["START_EVENT"] = "conditionalStartEvent";
    TaskTypes["SERVICE_CALL"] = "serviceTask";
    TaskTypes["END_EVENT"] = "terminateEndEvent";
    return TaskTypes;
}(TaskTypes || {});
var CustomerPhase = /*#__PURE__*/ function(CustomerPhase) {
    CustomerPhase["TESTING"] = "TESTING";
    CustomerPhase["PARALLEL"] = "PARALLEL";
    CustomerPhase["ACTIVE"] = "ACTIVE";
    CustomerPhase["LIVE"] = "LIVE";
    CustomerPhase["PRODUCTION"] = "PRODUCTION";
    return CustomerPhase;
}(CustomerPhase || {});
var OrgLevels = /*#__PURE__*/ function(OrgLevels) {
    OrgLevels[OrgLevels["BUSINESS"] = 0] = "BUSINESS";
    OrgLevels[OrgLevels["HEALTH_SYSTEM"] = 1] = "HEALTH_SYSTEM";
    OrgLevels[OrgLevels["HOSPITAL"] = 2] = "HOSPITAL";
    OrgLevels[OrgLevels["PHYSICIAN_ORGANIZATION"] = 3] = "PHYSICIAN_ORGANIZATION";
    return OrgLevels;
}(OrgLevels || {});
var ORGS = /*#__PURE__*/ function(ORGS) {
    ORGS["BUSINESS"] = "BUSINESS";
    ORGS["HEALTH_SYSTEM"] = "HEALTH_SYSTEM";
    ORGS["HOSPITAL"] = "HOSPITAL";
    ORGS["PHYSICIAN_ORGANIZATION"] = "PHYSICIAN_ORGANIZATION";
    return ORGS;
}(ORGS || {});
var FilterTypes = /*#__PURE__*/ function(FilterTypes) {
    FilterTypes["IN"] = "IN";
    FilterTypes["LIKE"] = "LIKE";
    FilterTypes["EQ"] = "EQ";
    FilterTypes["BETWEEN"] = "BETWEEN";
    return FilterTypes;
}(FilterTypes || {});
var FilterKeys = /*#__PURE__*/ function(FilterKeys) {
    FilterKeys["TENANT"] = "tenant_code";
    FilterKeys["PROCEDURE_TYPE_CATEGORY"] = "procedure_type_category";
    FilterKeys["CASE_STATUS"] = "case_status";
    FilterKeys["DATE_OF_SERVICE"] = "date_of_service";
    FilterKeys["DATE_OF_AUTOMATION"] = "date_of_automation";
    return FilterKeys;
}(FilterKeys || {});
var FeatureSources = /*#__PURE__*/ function(FeatureSources) {
    FeatureSources["NOTE"] = "raw_body";
    FeatureSources["NOTE_CONVERTED"] = "body";
    FeatureSources["BODY_REGION"] = "body_region";
    FeatureSources["PROCEDURE_TYPE"] = "procedure_type";
    FeatureSources["PROCEDURE_CATEGORY"] = "procedure_category";
    FeatureSources["EXAM_DESCRIPTION"] = "exam_description";
    FeatureSources["EXAM_TYPE"] = "exam_type";
    FeatureSources["REASON_FOR_VISIT"] = "reason_for_visit";
    FeatureSources["WORK_QUEUE_NAME"] = "work_queue_name";
    return FeatureSources;
}(FeatureSources || {});
var FeatureTypes = /*#__PURE__*/ function(FeatureTypes) {
    FeatureTypes["MAPPING"] = "MAPPING";
    FeatureTypes["NGRAM"] = "ngram";
    FeatureTypes["CATEGORICAL"] = "categorical";
    FeatureTypes["PRIOR"] = "prior";
    return FeatureTypes;
}(FeatureTypes || {});
var Provenances = /*#__PURE__*/ function(Provenances) {
    Provenances["CLINICAL"] = "source";
    Provenances["PREDICTION"] = "CMX";
    Provenances["MANUAL"] = "manual";
    Provenances["CQA"] = "cqa";
    return Provenances;
}(Provenances || {});
var ArtifactTypes = /*#__PURE__*/ function(ArtifactTypes) {
    ArtifactTypes["CODED"] = "submission to payer";
    ArtifactTypes["MAPPED"] = "dictionary lookups (internal)";
    ArtifactTypes["CLINICAL"] = "source system";
    ArtifactTypes["CLAIM"] = "historical data";
    ArtifactTypes["PREDICTION"] = "CodaMetrix Prediction Engine";
    ArtifactTypes["PROCESSED"] = "CodaMetrix";
    ArtifactTypes["SUBMITTED"] = "CodaMetrix";
    ArtifactTypes["REMITTANCE"] = "a response to the payer";
    ArtifactTypes["REFERRAL"] = "referral";
    ArtifactTypes["MANUAL"] = "manual";
    ArtifactTypes["CQA"] = "CodaMetrix QA";
    return ArtifactTypes;
}(ArtifactTypes || {});
// This enum is sorted by the order which these artifacts are created in automate
//https://codametrix.atlassian.net/wiki/spaces/DEV/pages/3654778881/Invoice+Assembly+-+Invoice+Types
var CaseArtifactTypes = /*#__PURE__*/ function(CaseArtifactTypes) {
    CaseArtifactTypes["CLINICAL"] = "CLINICAL";
    CaseArtifactTypes["MAPPED"] = "MAPPED";
    CaseArtifactTypes["PREDICTION"] = "PREDICTION";
    CaseArtifactTypes["ASSEMBLED"] = "ASSEMBLED";
    CaseArtifactTypes["CODED"] = "CODED";
    CaseArtifactTypes["PROCESSED"] = "PROCESSED";
    CaseArtifactTypes["SUBMITTED"] = "SUBMITTED";
    CaseArtifactTypes["CLAIM"] = "CLAIM";
    CaseArtifactTypes["REFERRAL"] = "REFERRAL";
    CaseArtifactTypes["REMITTANCE"] = "REMITTANCE";
    return CaseArtifactTypes;
}(CaseArtifactTypes || {});
// This enum is sorted by the order which these invoices are created in automate
//https://codametrix.atlassian.net/wiki/spaces/DEV/pages/3654778881/Invoice+Assembly+-+Invoice+Types
var InvoiceTypes = /*#__PURE__*/ function(InvoiceTypes) {
    InvoiceTypes["CLINICAL"] = "CLINICAL";
    InvoiceTypes["MAPPED"] = "MAPPED";
    // Prediciton invoice is a UI specific invoice for retrieving predicted codes regardless of confidence/what is on the assembled invoice
    InvoiceTypes["PREDICTION"] = "PREDICTION";
    InvoiceTypes["ASSEMBLED"] = "ASSEMBLED";
    InvoiceTypes["CODED"] = "CODED";
    InvoiceTypes["PROCESSED"] = "PROCESSED";
    InvoiceTypes["SUBMITTED"] = "SUBMITTED";
    InvoiceTypes["CLAIM"] = "CLAIM";
    InvoiceTypes["REFERRAL"] = "REFERRAL";
    InvoiceTypes["REMITTANCE"] = "REMITTANCE";
    InvoiceTypes["SHARED_CODES"] = "SHARED_CODES";
    return InvoiceTypes;
}(InvoiceTypes || {});
var IdentifierTypes = /*#__PURE__*/ function(IdentifierTypes) {
    IdentifierTypes["PATIENT_IDENTIFIER"] = "PATIENT_IDENTIFIER";
    IdentifierTypes["PROVIDER_IDENTIFIER"] = "PROVIDER_IDENTIFIER";
    IdentifierTypes["PLACER_ORDER_NUMBER"] = "PLACER_ORDER_NUMBER";
    IdentifierTypes["FILLER_ORDER_NUMBER"] = "FILLER_ORDER_NUMBER";
    IdentifierTypes["ACCOUNT_NUMBER"] = "ACCOUNT_NUMBER";
    IdentifierTypes["VISIT_NUMBER"] = "VISIT_NUMBER";
    return IdentifierTypes;
}(IdentifierTypes || {});
var AuthToken = /*#__PURE__*/ function(AuthToken) {
    AuthToken["REQUEST"] = "TOKEN_REQUEST";
    AuthToken["RESPONSE"] = "TOKEN_RESPONSE";
    return AuthToken;
}(AuthToken || {});
var SpanLevel = /*#__PURE__*/ function(SpanLevel) {
    SpanLevel["SENTENCE"] = "sentence";
    SpanLevel["NGRAM"] = "ngram";
    return SpanLevel;
}(SpanLevel || {});
var TimelineStatus = /*#__PURE__*/ function(TimelineStatus) {
    TimelineStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TimelineStatus["COMPLETE"] = "COMPLETE";
    TimelineStatus["STARTED"] = "STARTED";
    return TimelineStatus;
}(TimelineStatus || {});
var DictionaryStatus = /*#__PURE__*/ function(DictionaryStatus) {
    DictionaryStatus["DRAFT"] = "draft";
    DictionaryStatus["PUBLISHED"] = "published";
    DictionaryStatus["ARCHIVED"] = "archived";
    return DictionaryStatus;
}(DictionaryStatus || {});
var DictionaryEditStatus = /*#__PURE__*/ function(DictionaryEditStatus) {
    DictionaryEditStatus["DELETE"] = "delete";
    DictionaryEditStatus["UPDATE"] = "update";
    DictionaryEditStatus["ADD"] = "add";
    DictionaryEditStatus["RETIRE"] = "retire";
    return DictionaryEditStatus;
}(DictionaryEditStatus || {});
var CaseDetailMode = /*#__PURE__*/ function(CaseDetailMode) {
    CaseDetailMode["EDIT"] = "code-edit";
    CaseDetailMode["DASHBOARD"] = "dashboard";
    CaseDetailMode["QA"] = "cqa";
    return CaseDetailMode;
}(CaseDetailMode || {});
var ChargeSessionType = /*#__PURE__*/ function(ChargeSessionType) {
    ChargeSessionType["PROFESSIONAL"] = "professional";
    ChargeSessionType["TECHNICAL"] = "technical";
    ChargeSessionType["PRO_TECH"] = "pro-tech";
    return ChargeSessionType;
}(ChargeSessionType || {});
var ChargeSessionCodeType = /*#__PURE__*/ function(ChargeSessionCodeType) {
    ChargeSessionCodeType["DIAGNOSIS"] = "diagnosis";
    ChargeSessionCodeType["PROCEDURE"] = "procedure";
    ChargeSessionCodeType["MODIFIER"] = "modifier";
    return ChargeSessionCodeType;
}(ChargeSessionCodeType || {});
var ChargeSessionCodeProvenance = /*#__PURE__*/ function(ChargeSessionCodeProvenance) {
    ChargeSessionCodeProvenance["ICD"] = "ICD";
    ChargeSessionCodeProvenance["CPT"] = "CPT";
    ChargeSessionCodeProvenance["HCPCS"] = "HCPCS";
    ChargeSessionCodeProvenance["TECH"] = "TECH";
    ChargeSessionCodeProvenance["MODIFIER"] = "MODIFIER";
    return ChargeSessionCodeProvenance;
}(ChargeSessionCodeProvenance || {});
var ChargeSessionProviderRole = /*#__PURE__*/ function(ChargeSessionProviderRole) {
    ChargeSessionProviderRole["PERFORMING"] = "performing_provider";
    ChargeSessionProviderRole["BILLING"] = "billing_provider";
    ChargeSessionProviderRole["BILLING_ASSISTANT"] = "billing_provider_assistant";
    ChargeSessionProviderRole["ORDERING"] = "ordering_provider";
    ChargeSessionProviderRole["REFERRING"] = "referring_provider";
    ChargeSessionProviderRole["RENDERING"] = "rendering_provider";
    return ChargeSessionProviderRole;
}(ChargeSessionProviderRole || {});
var ServiceLines = /*#__PURE__*/ function(ServiceLines) {
    ServiceLines["SURGERY"] = "Surgery";
    ServiceLines["RADIOLOGY"] = "Radiology";
    ServiceLines["PATHOLOGY"] = "Pathology";
    ServiceLines["AUTOMATE"] = "Automate";
    ServiceLines["BEDSIDE_PRO"] = "Bedside Pro";
    ServiceLines["BEDSIDE_PRO_NO_SPACE"] = "BedsidePro";
    ServiceLines["IPC_LONG_NAME"] = "Inpatient Professional Coding";
    ServiceLines["IPC"] = "IPC";
    ServiceLines["ALL"] = "*";
    return ServiceLines;
}(ServiceLines || {});
var CrudOperations = /*#__PURE__*/ function(CrudOperations) {
    CrudOperations["CREATE"] = "CREATE";
    CrudOperations["UPDATE"] = "UPDATE";
    CrudOperations["DELETE"] = "DELETE";
    return CrudOperations;
}(CrudOperations || {});
var InvoiceStatus = /*#__PURE__*/ function(InvoiceStatus) {
    InvoiceStatus["SUBMITTED"] = "SUBMITTED";
    InvoiceStatus["IN_PROGRESS"] = "IN_PROGRESS";
    InvoiceStatus["NEW"] = "NEW";
    return InvoiceStatus;
}(InvoiceStatus || {});
var InvoiceEditorMode = /*#__PURE__*/ function(InvoiceEditorMode) {
    InvoiceEditorMode["EDITOR"] = "EDITOR";
    InvoiceEditorMode["ADDITION"] = "ADDITION";
    return InvoiceEditorMode;
}(InvoiceEditorMode || {});
var UserPreferenceKey = /*#__PURE__*/ function(UserPreferenceKey) {
    UserPreferenceKey["DEFAULT_USER_CONTEXT"] = "codametrix.user.preference.default_user_context";
    UserPreferenceKey["DEFAULT_USER_SERVICE_LINE"] = "codametrix.user.preference.default_service_line";
    UserPreferenceKey["DEFAULT_HOMEPAGE"] = "codametrix.user.preference.default_homepage";
    UserPreferenceKey["DEMOGRAPHICS_PANEL_LOCATION"] = "codametrix.user.preference.demographics_panel_location";
    UserPreferenceKey["DEMOGRAPHICS_PANEL_VISIBILITY"] = "codametrix.user.preference.demographics_panel_visibility";
    return UserPreferenceKey;
}(UserPreferenceKey || {});
var UserPreferenceSection = /*#__PURE__*/ function(UserPreferenceSection) {
    UserPreferenceSection["USER_PREFERENCE"] = "user_preference";
    UserPreferenceSection["USER_SECURITY"] = "user_security";
    return UserPreferenceSection;
}(UserPreferenceSection || {});
//Valid Configuration Sections for /configuration/section/{ConfigurationSection}/... calls
var ConfigurationSection = /*#__PURE__*/ function(ConfigurationSection) {
    ConfigurationSection["SUBNAV"] = "subnav";
    ConfigurationSection["CODER_CONFIG"] = "coder_config";
    return ConfigurationSection;
}(ConfigurationSection || {});
var ConfigurationKeyName = /*#__PURE__*/ function(ConfigurationKeyName) {
    ConfigurationKeyName["AMPLIFY_INVOICE_TYPES"] = "amplify_invoice_types";
    ConfigurationKeyName["MULTI_CODESET_GENERAL"] = "multi_codeset_general_feature_flag";
    ConfigurationKeyName["AUTOMATE_CHECK_CODE_SOURCE_PREDICTED_INVOICE"] = "automate_check_code_source_predicted_invoice";
    ConfigurationKeyName["CODE_SOURCE_DISPLAY_INVOICE_TYPES"] = "code_source_display_invoice_types";
    return ConfigurationKeyName;
}(ConfigurationKeyName || {});
var PermissionLevel = /*#__PURE__*/ function(PermissionLevel) {
    PermissionLevel["READ_ONLY"] = "READ_ONLY";
    PermissionLevel["FULL_ACCESS"] = "FULL_ACCESS";
    PermissionLevel["DENY"] = "DENY";
    return PermissionLevel;
}(PermissionLevel || {});
var ResourceId = /*#__PURE__*/ function(ResourceId) {
    ResourceId["SEARCH"] = "search";
    ResourceId["CASES"] = "cases";
    ResourceId["DASHBOARD"] = "dashboard";
    ResourceId["ORGANIZATIONS"] = "organizations";
    ResourceId["ASSIGNING_AUTHORITIES"] = "assigning_authorities";
    ResourceId["METADATA"] = "metadata";
    ResourceId["PROCESS_DEFINITION_MANAGEMENT"] = "process_definition_management";
    ResourceId["ASSOCIATION_GROUP"] = "association_group";
    ResourceId["DICTIONARY"] = "dictionary";
    ResourceId["POWER_FEATURES"] = "power_features";
    ResourceId["CASE_CONFIGURATION"] = "case_configuration";
    ResourceId["CODE_CASE"] = "code_case";
    ResourceId["ENABLE_RELATED_CASE_CODES_UI"] = "enable_related_case_codes_ui";
    ResourceId["IMPORT_AMPLIFY"] = "import_amplify";
    ResourceId["GROUPS"] = "groups";
    ResourceId["VOID_CASE"] = "void_case";
    ResourceId["MERGE_CASE"] = "merge_case";
    ResourceId["CREATE_CASE"] = "create_case";
    ResourceId["CODER_FEEDBACK"] = "coder_feedback";
    ResourceId["TIMELINE_INFINITE_LOAD"] = "timeline_infinite_load";
    ResourceId["ATTACH_DOCS"] = "attach_docs";
    ResourceId["PRODUCTIVITY_TRACKER"] = "productivity_tracker";
    ResourceId["DIAGNOSIS_CODE_SUGGESTION"] = "diagnosis_code_suggestion";
    ResourceId["AMPLIFY_CASE_RUN_V2"] = "amplify_case_run_v2";
    ResourceId["CODER_NOTES"] = "coder_notes";
    ResourceId["TRANSACTION_V2"] = "transaction_v2";
    ResourceId["GET_CASERUN_WITH_REFRESH"] = "get_caserun_with_refresh";
    ResourceId["USE_PROVIDER_DIRECTORY_LOCATIONS"] = "use_provider_directory_locations";
    ResourceId["MULTI_CODESET_FEATURE"] = "multi_codeset_general_feature_flag";
    ResourceId["SHOW_RELATED_CASE_FILTER"] = "show_related_cases_filter";
    ResourceId["WORKLIST_MAINTENANCE_WINDOW"] = "worklist_maintenance_window";
    ResourceId["DISPLAY_ALL_CASE_RUNS"] = "display_all_case_runs";
    ResourceId["USE_DATAACCESS_AMPLIFY"] = "use_dataaccess_amplify";
    ResourceId["QUEUE_PRIORITY_ORDER"] = "queue_priority_order";
    ResourceId["CODER_VIEW_V2"] = "coder_view_v2";
    ResourceId["NATIVE_ANALYTICS"] = "native_analytics";
    ResourceId["CASE_ANALYTICS"] = "case_analytics";
    return ResourceId;
}(ResourceId || {});
var CaseConfigSection = /*#__PURE__*/ function(CaseConfigSection) {
    CaseConfigSection["GENERAL"] = "GENERAL";
    return CaseConfigSection;
}(CaseConfigSection || {});
var FeedbackMeta = /*#__PURE__*/ function(FeedbackMeta) {
    FeedbackMeta["WARNING"] = "WARNING";
    FeedbackMeta["ERROR"] = "ERROR";
    FeedbackMeta["SUCCESS"] = "SUCCESS";
    return FeedbackMeta;
}(FeedbackMeta || {});
var DictionaryRequestStatus = /*#__PURE__*/ function(DictionaryRequestStatus) {
    DictionaryRequestStatus["INITIALIZED"] = "INITIALIZED";
    DictionaryRequestStatus["COMPLETED"] = "COMPLETED";
    DictionaryRequestStatus["CELL_REFERENCE_VALIDATION_COMPLETED"] = "CELL_REFERENCE_VALIDATION_COMPLETED";
    DictionaryRequestStatus["COLUMN_UPDATE_COMPLETED"] = "COLUMN_UPDATE_COMPLETED";
    DictionaryRequestStatus["CSV_PARSE_COMPLETED"] = "CSV_PARSE_COMPLETED";
    DictionaryRequestStatus["ROW_UPDATE_COMPLETED"] = "ROW_UPDATE_COMPLETED";
    return DictionaryRequestStatus;
}(DictionaryRequestStatus || {});
var ProcessInstanceActions = /*#__PURE__*/ function(ProcessInstanceActions) {
    ProcessInstanceActions["ALL_INVOICES"] = "ALL_INVOICES";
    ProcessInstanceActions["INVOICE_AVAILABLE"] = "INVOICE_AVAILABLE";
    ProcessInstanceActions["INVOICE_SUBMITTED"] = "INVOICE_SUBMITTED";
    ProcessInstanceActions["DASHBOARD_INVOICE_AVAILABLE"] = "DASHBOARD_INVOICE_AVAILABLE";
    ProcessInstanceActions["FETCH_SOURCE_INVOICES"] = "FETCH_SOURCE_INVOICES";
    return ProcessInstanceActions;
}(ProcessInstanceActions || {});
var AuthenticationChannelEvents = /*#__PURE__*/ function(AuthenticationChannelEvents) {
    AuthenticationChannelEvents["BOOTSTRAP_AUTH"] = "bootstrapAuth";
    AuthenticationChannelEvents["BOOTSTRAP_AUTH_RESPONSE"] = "bootstrapAuthResponse";
    AuthenticationChannelEvents["TOKEN_UPDATE"] = "TOKEN_UPDATE";
    AuthenticationChannelEvents["CSRF_TOKEN_UPDATE"] = "CSRF_TOKEN_UPDATE";
    AuthenticationChannelEvents["CSRF_TOKEN_CLEARED"] = "CSRF_TOKEN_CLEARED";
    return AuthenticationChannelEvents;
}(AuthenticationChannelEvents || {});
var UIModesEnum = /*#__PURE__*/ function(UIModesEnum) {
    UIModesEnum["EPIC_EMBEDDED"] = "EPIC_EMBEDDED";
    UIModesEnum["STANDALONE"] = "STANDALONE";
    UIModesEnum["PLAYGROUND"] = "PLAYGROUND";
    return UIModesEnum;
}(UIModesEnum || {});
var UIViewEnum = /*#__PURE__*/ function(UIViewEnum) {
    UIViewEnum["AUTOMATE"] = "AUTOMATE";
    UIViewEnum["AMPLIFY"] = "AMPLIFY";
    return UIViewEnum;
}(UIViewEnum || {});
var ChargeTypes = /*#__PURE__*/ function(ChargeTypes) {
    ChargeTypes["TRACKING"] = "tracking";
    ChargeTypes["STANDARD"] = "standard";
    ChargeTypes["LEGACY"] = "legacy";
    ChargeTypes["UNKNOWN"] = "unknown";
    return ChargeTypes;
}(ChargeTypes || {});
var CodeTypes = /*#__PURE__*/ function(CodeTypes) {
    CodeTypes["PROCEDURE"] = "procedure";
    CodeTypes["MODIFIER"] = "modifier";
    return CodeTypes;
}(CodeTypes || {});
var ModifierTypes = /*#__PURE__*/ function(ModifierTypes) {
    ModifierTypes["PRO"] = "PRO";
    ModifierTypes["TECH"] = "TECH";
    return ModifierTypes;
}(ModifierTypes || {});
var IssueTypeErrors = /*#__PURE__*/ function(IssueTypeErrors) {
    IssueTypeErrors["CLAIMS_EDIT"] = "invoice.claims_edit.invalid";
    IssueTypeErrors["CCI_EDIT"] = "invoice.cci_edit.invalid";
    IssueTypeErrors["CUSTOM_RULES"] = "invoice.custom_rules.invalid";
    return IssueTypeErrors;
}(IssueTypeErrors || {});
var AmplifyErrorSources = /*#__PURE__*/ function(AmplifyErrorSources) {
    AmplifyErrorSources["CLAIMS_EDIT"] = "CLAIMS_EDIT";
    AmplifyErrorSources["CCI_EDIT"] = "CCI_EDIT";
    AmplifyErrorSources["STANDARD"] = "STANDARD";
    AmplifyErrorSources["CUSTOM_RULES"] = "CUSTOM_RULES";
    AmplifyErrorSources["CUSTOM"] = "CUSTOM";
    AmplifyErrorSources["MERGE_SPLIT_HISTORY"] = "MERGE_SPLIT_HISTORY";
    AmplifyErrorSources["UNRESOLVED_DOCUMENT"] = "UNRESOLVED_DOCUMENT";
    AmplifyErrorSources["HOLD"] = "HOLD";
    return AmplifyErrorSources;
}(AmplifyErrorSources || {});
// this file points to the parameters that are
// used in the EPIC launch cal.
var LaunchParams = /*#__PURE__*/ function(LaunchParams) {
    LaunchParams["TRANSACTION_IDS"] = "transactionIds";
    LaunchParams["UCL_IDS"] = "uclIds";
    LaunchParams["PROVIDER_ID"] = "providerID";
    LaunchParams["PROVIDER_NAME"] = "providerName";
    LaunchParams["PATIENT_ID"] = "patientIdentifier";
    LaunchParams["VISIT_DATE"] = "serviceDate";
    LaunchParams["VISIT_CSN"] = "visitNumber";
    LaunchParams["EXTERNAL_USERNAME"] = "external_username";
    LaunchParams["LAUNCH_POINT"] = "launchPoint";
    return LaunchParams;
}(LaunchParams || {});
var CapabilityAvailabilityReason = /*#__PURE__*/ function(CapabilityAvailabilityReason) {
    /**
   * Whether a user's role prevents them from having access to a feature.
   */ CapabilityAvailabilityReason["ROLE"] = "ROLE";
    /**
   * Whether a feature is not generally available.
   */ CapabilityAvailabilityReason["EMBARGO"] = "EMBARGO";
    /**
   * Whether a product mis-match prevents a feature from being available to the user.
   */ CapabilityAvailabilityReason["PRODUCT_EXCLUDED"] = "PRODUCT_EXCLUDED";
    /**
   * Whether a configuration (usually driven by an org config) prevents a feature from being available.
   */ CapabilityAvailabilityReason["CONFIGURATION"] = "CONFIGURATION";
    return CapabilityAvailabilityReason;
}(CapabilityAvailabilityReason || {});
var AmplifyCapabilities = /*#__PURE__*/ function(AmplifyCapabilities) {
    AmplifyCapabilities["coding"] = "coding";
    AmplifyCapabilities["improvements"] = "improvements";
    AmplifyCapabilities["pagination"] = "pagination";
    AmplifyCapabilities["cancelCase"] = "cancelCase";
    AmplifyCapabilities["submitCase"] = "submitCase";
    AmplifyCapabilities["viewOnlyCase"] = "viewOnlyCase";
    AmplifyCapabilities["holdCase"] = "holdCase";
    AmplifyCapabilities["toggleChargeableCase"] = "toggleChargeableCase";
    AmplifyCapabilities["caseEdit"] = "caseEdit";
    AmplifyCapabilities["attachDocs"] = "attachDocs";
    AmplifyCapabilities["productivityTracker"] = "productivityTracker";
    AmplifyCapabilities["codeSourcesFeatures"] = "codeSourcesFeatures";
    return AmplifyCapabilities;
}(AmplifyCapabilities || {});
var DocumentStatus = /*#__PURE__*/ function(DocumentStatus) {
    DocumentStatus["OPEN"] = "OPEN";
    DocumentStatus["RESOLVED"] = "RESOLVED";
    DocumentStatus["INCOMPLETE"] = "INCOMPLETE";
    DocumentStatus["NOT_CORRECTED"] = "NOT_CORRECTED";
    return DocumentStatus;
}(DocumentStatus || {});
var DocumentQueryType = /*#__PURE__*/ function(DocumentQueryType) {
    DocumentQueryType["REQUIRED"] = "Yes";
    DocumentQueryType["CODERS_CHOICE"] = "Yes/No";
    DocumentQueryType["NOT_REQUIRED"] = "NO";
    DocumentQueryType["NO_LOG"] = "No-Log";
    return DocumentQueryType;
}(DocumentQueryType || {});
var ProcessStatusLabel = /*#__PURE__*/ function(ProcessStatusLabel) {
    ProcessStatusLabel["AUTOMATE"] = "Automate";
    ProcessStatusLabel["IMPORTING"] = "Importing";
    ProcessStatusLabel["READY_FOR_CODING"] = "Ready for coding";
    ProcessStatusLabel["VOIDED"] = "Voided";
    ProcessStatusLabel["SUBMITTED"] = "Submitted";
    ProcessStatusLabel["NON_CHARGEABLE"] = "Non-Chargeable";
    ProcessStatusLabel["IN_QA"] = "In QA";
    return ProcessStatusLabel;
}(ProcessStatusLabel || {});
var ImprovementDictionaryProps = /*#__PURE__*/ function(ImprovementDictionaryProps) {
    ImprovementDictionaryProps["DESCRIPTION"] = "Documentation Improvement Opportunity Description";
    ImprovementDictionaryProps["SEND_QUERY"] = "Send Query";
    ImprovementDictionaryProps["EPIC_QUERY_TEMPLATE"] = "Epic Query Template";
    ImprovementDictionaryProps["KEY"] = "Key";
    ImprovementDictionaryProps["ERROR_CODE"] = "Error Code";
    return ImprovementDictionaryProps;
}(ImprovementDictionaryProps || {});
var HoldReasonType = /*#__PURE__*/ function(HoldReasonType) {
    HoldReasonType["HOLD"] = "HOLD";
    HoldReasonType["HOLD_FOR_DOCUMENTATION_QUERY"] = "HOLD_FOR_DOCUMENTATION_QUERY";
    HoldReasonType["HOLD_FOR_MANAGER_REVIEW"] = "HOLD_FOR_MANAGER_REVIEW";
    HoldReasonType["OFF_HOLD"] = "OFF_HOLD";
    return HoldReasonType;
}(HoldReasonType || {});
var CaseAccessState = /*#__PURE__*/ function(CaseAccessState) {
    /**
   * No access to the case - not acquired or released
   * Alternativley can be termed as "FREE"
   */ CaseAccessState["NONE"] = "NONE";
    /**
   * Case access has been successfully acquired by current user
   */ CaseAccessState["ACQUIRED"] = "ACQUIRED";
    /**
   * Case access conflict - another user has access
   */ CaseAccessState["CONFLICT"] = "CONFLICT";
    return CaseAccessState;
}(CaseAccessState || {});
var TitleTabsEnum = /*#__PURE__*/ function(TitleTabsEnum) {
    TitleTabsEnum["CHANGES_TEXT"] = "See changes to this case";
    return TitleTabsEnum;
}(TitleTabsEnum || {});
var MiniTabLabels = /*#__PURE__*/ function(MiniTabLabels) {
    MiniTabLabels["CHARGES_LABEL"] = "Charges";
    MiniTabLabels["RELATED_LABEL"] = "Related";
    MiniTabLabels["ACTIVITY_LABEL"] = "Activity";
    MiniTabLabels["IMPROVEMENTS_LABEL"] = "Improvements";
    MiniTabLabels["CHARGES_DESCRIPTION"] = "Code this case";
    MiniTabLabels["RELATED_DESCRIPTION"] = "See related cases";
    MiniTabLabels["ACTIVITY_DESCRIPTION"] = "See changes to this case";
    MiniTabLabels["IMPROVEMENTS_DESCRIPTION"] = "See document improvement reasons";
    MiniTabLabels["NOTES_LABEL"] = "Notes";
    MiniTabLabels["CODE_SOURCES"] = "Code Sources";
    MiniTabLabels["CODE_SOURCES_DESCRIPTION"] = "See codes and their sources";
    return MiniTabLabels;
}(MiniTabLabels || {});
var CaseAlertType = /*#__PURE__*/ function(CaseAlertType) {
    CaseAlertType["WARNING"] = "WARNING";
    CaseAlertType["ERROR"] = "ERROR";
    CaseAlertType["INFO"] = "INFO";
    return CaseAlertType;
}(CaseAlertType || {});
var CursorOperation = /*#__PURE__*/ function(CursorOperation) {
    CursorOperation["PREVIOUS"] = "prev";
    CursorOperation["NEXT"] = "next";
    return CursorOperation;
}(CursorOperation || {});
var ResponseStatus = /*#__PURE__*/ function(ResponseStatus) {
    ResponseStatus["SUCCESS"] = "success";
    ResponseStatus["FAILURE"] = "failure";
    return ResponseStatus;
}(ResponseStatus || {});
var DateFilterLabelEnum = /*#__PURE__*/ function(DateFilterLabelEnum) {
    DateFilterLabelEnum["ALL_EVENTS"] = "All Events";
    DateFilterLabelEnum["SEVEN_DAYS"] = "7 Days";
    DateFilterLabelEnum["THIRTY_DAYS"] = "30 Days";
    DateFilterLabelEnum["THREE_YEARS"] = "3 Years";
    DateFilterLabelEnum["ON_DOS"] = "On Date of service";
    return DateFilterLabelEnum;
}(DateFilterLabelEnum || {});
var ProviderType = /*#__PURE__*/ function(ProviderType) {
    ProviderType["BILLING_PROVIDER"] = "BILLING_PROVIDER";
    ProviderType["REFERRING_PROVIDER"] = "REFERRING_PROVIDER";
    ProviderType["PERFORMING_PROVIDER"] = "PERFORMING_PROVIDER";
    return ProviderType;
}(ProviderType || {});
var RequiredField = /*#__PURE__*/ function(RequiredField) {
    RequiredField["PERFORMING_PROVIDER"] = "performingProviderNumber";
    RequiredField["DATE_OF_SERVICE"] = "dateOfService";
    RequiredField["DEPARTMENT"] = "departmentCode";
    RequiredField["BILLING_PROVIDER"] = "billingProviderNumber";
    RequiredField["REFERRING_PROVIDER"] = "referringProviderNumber";
    RequiredField["BILLING_AREA"] = "feeSchedule";
    return RequiredField;
}(RequiredField || {});
var HoldReasonLabel = /*#__PURE__*/ function(HoldReasonLabel) {
    HoldReasonLabel["HOLD"] = "Hold";
    HoldReasonLabel["HOLD_FOR_DOCUMENTATION_QUERY"] = "Hold: Documentation Query";
    HoldReasonLabel["HOLD_FOR_MANAGER_REVIEW"] = "Hold: Manager Review";
    HoldReasonLabel["OFF_HOLD"] = "Off Hold";
    return HoldReasonLabel;
}(HoldReasonLabel || {});
var DictionaryFilterDefault = /*#__PURE__*/ function(DictionaryFilterDefault) {
    DictionaryFilterDefault["INCLUDE"] = "Include";
    DictionaryFilterDefault["EXCLUDE"] = "Exclude";
    return DictionaryFilterDefault;
}(DictionaryFilterDefault || {});
// Feature Flag for the code bench
var BenchMode = /*#__PURE__*/ function(BenchMode) {
    BenchMode["CODE"] = "CODE";
    BenchMode["GRADE"] = "GRADE";
    return BenchMode;
}(BenchMode || {});
// Field Type enum, used by reusable workbench components
var FieldType = /*#__PURE__*/ function(FieldType) {
    FieldType["SelectList"] = "selectList";
    FieldType["Button"] = "button";
    FieldType["Text"] = "text";
    FieldType["Icon"] = "icon";
    FieldType["Code"] = "code";
    FieldType["TextInput"] = "textInput";
    return FieldType;
}(FieldType || {});
var CodeAssessmentRiskCategory = /*#__PURE__*/ function(CodeAssessmentRiskCategory) {
    CodeAssessmentRiskCategory["CORRECT"] = "CORRECT";
    CodeAssessmentRiskCategory["INCORRECT"] = "INCORRECT";
    CodeAssessmentRiskCategory["MISSED"] = "MISSED";
    return CodeAssessmentRiskCategory;
}(CodeAssessmentRiskCategory || {});
var CodeSearchType = /*#__PURE__*/ function(CodeSearchType) {
    CodeSearchType["CPT"] = "CPT";
    CodeSearchType["ICD"] = "ICD";
    CodeSearchType["MODIFIER"] = "MODIFIER";
    return CodeSearchType;
}(CodeSearchType || {});
var SugggestedCodeType = /*#__PURE__*/ function(SugggestedCodeType) {
    SugggestedCodeType["RELATED_CASE"] = "RELATED_CASE";
    SugggestedCodeType["CURRENT_CASE"] = "CURRENT_CASE";
    SugggestedCodeType["FROM_SOURCES"] = "FROM_SOURCES";
    return SugggestedCodeType;
}(SugggestedCodeType || {});
var CoderNotesLookupType = /*#__PURE__*/ function(CoderNotesLookupType) {
    CoderNotesLookupType["ENCOUNTER_UID"] = "ENCOUNTER_UID";
    CoderNotesLookupType["ACCESSION_NUMBER"] = "ACCESSION_NUMBER";
    return CoderNotesLookupType;
}(CoderNotesLookupType || {});
var CoderNotesLookupTypeName = /*#__PURE__*/ function(CoderNotesLookupTypeName) {
    CoderNotesLookupTypeName["ENCOUNTER_UID"] = "encounter_uid";
    CoderNotesLookupTypeName["ACCESSION_NUMBER"] = "accession_number";
    CoderNotesLookupTypeName["CQA_CODER_COMMENT"] = "lookup_reference";
    CoderNotesLookupTypeName["CQA_FEEDBACK_COMMENT"] = "lookup_reference";
    return CoderNotesLookupTypeName;
}(CoderNotesLookupTypeName || {});

var commonEnums$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccelerateProcessStatus: AccelerateProcessStatus,
  AmplifyCapabilities: AmplifyCapabilities,
  AmplifyErrorSources: AmplifyErrorSources,
  ArtifactTypes: ArtifactTypes,
  AuthToken: AuthToken,
  AuthenticationChannelEvents: AuthenticationChannelEvents,
  BenchMode: BenchMode,
  CapabilityAvailabilityReason: CapabilityAvailabilityReason,
  CaseAccessState: CaseAccessState,
  CaseAlertType: CaseAlertType,
  CaseArtifactTypes: CaseArtifactTypes,
  CaseConfigSection: CaseConfigSection,
  CaseDataGroup: CaseDataGroup,
  CaseDataTypes: CaseDataTypes,
  CaseDetailMode: CaseDetailMode,
  CaseStatus: CaseStatus,
  ChargeSessionCodeProvenance: ChargeSessionCodeProvenance,
  ChargeSessionCodeType: ChargeSessionCodeType,
  ChargeSessionProviderRole: ChargeSessionProviderRole,
  ChargeSessionType: ChargeSessionType,
  ChargeTypes: ChargeTypes,
  CodeAssessmentRiskCategory: CodeAssessmentRiskCategory,
  CodeChangeType: CodeChangeType,
  CodeSearchType: CodeSearchType,
  CodeType: CodeType,
  CodeTypes: CodeTypes,
  CoderNotesLookupType: CoderNotesLookupType,
  CoderNotesLookupTypeName: CoderNotesLookupTypeName,
  ConfigurationKeyName: ConfigurationKeyName,
  ConfigurationSection: ConfigurationSection,
  CrudOperations: CrudOperations,
  CursorOperation: CursorOperation,
  CustomerPhase: CustomerPhase,
  DateFilterLabelEnum: DateFilterLabelEnum,
  DictionaryEditStatus: DictionaryEditStatus,
  DictionaryFilterDefault: DictionaryFilterDefault,
  DictionaryRequestStatus: DictionaryRequestStatus,
  DictionaryStatus: DictionaryStatus,
  DocumentQueryType: DocumentQueryType,
  DocumentStatus: DocumentStatus,
  EditorIssueLevel: EditorIssueLevel,
  EditorIssueProvenance: EditorIssueProvenance,
  EntriesMessageType: EntriesMessageType,
  EvidenceType: EvidenceType,
  FeatureSources: FeatureSources,
  FeatureTypes: FeatureTypes,
  FeedbackMeta: FeedbackMeta,
  FieldType: FieldType,
  FilterKeys: FilterKeys,
  FilterTypes: FilterTypes,
  Gen2CaseStatus: Gen2CaseStatus,
  Gen2ProcessStatus: Gen2ProcessStatus,
  HoldReasonLabel: HoldReasonLabel,
  HoldReasonType: HoldReasonType,
  IdentifierType: IdentifierType,
  IdentifierTypes: IdentifierTypes,
  ImprovementDictionaryProps: ImprovementDictionaryProps,
  InvoiceEditorMode: InvoiceEditorMode,
  InvoiceStatus: InvoiceStatus,
  InvoiceTypes: InvoiceTypes,
  IssueTypeErrors: IssueTypeErrors,
  LaunchParams: LaunchParams,
  MiniTabLabels: MiniTabLabels,
  ModifierTypes: ModifierTypes,
  NavigationAction: NavigationAction,
  ORGS: ORGS,
  OrgLevels: OrgLevels,
  PermissionLevel: PermissionLevel,
  ProcessInstanceActions: ProcessInstanceActions,
  ProcessQAStatus: ProcessQAStatus,
  ProcessRunType: ProcessRunType,
  ProcessStatus: ProcessStatus,
  ProcessStatusLabel: ProcessStatusLabel,
  Provenances: Provenances,
  ProviderType: ProviderType,
  RequiredField: RequiredField,
  ResourceId: ResourceId,
  ResourceTypes: ResourceTypes,
  ResponseStatus: ResponseStatus,
  ServiceLines: ServiceLines,
  SpanLevel: SpanLevel,
  SugggestedCodeType: SugggestedCodeType,
  SystemRole: SystemRole,
  TaskTypes: TaskTypes,
  TimelineStatus: TimelineStatus,
  TitleTabsEnum: TitleTabsEnum,
  UIModesEnum: UIModesEnum,
  UIViewEnum: UIViewEnum,
  UserPreferenceKey: UserPreferenceKey,
  UserPreferenceSection: UserPreferenceSection,
  uiStatus: uiStatus
});

var Methods = /*#__PURE__*/ function(Methods) {
    Methods["GET"] = "GET";
    Methods["POST"] = "POST";
    Methods["PUT"] = "PUT";
    Methods["DELETE"] = "DELETE";
    Methods["PATCH"] = "PATCH";
    Methods["HEAD"] = "HEAD";
    Methods["TRACE"] = "TRACE";
    Methods["OPTIONS"] = "OPTIONS";
    Methods["CONNECT"] = "CONNECT";
    return Methods;
}(Methods || {});

var ContentType = /*#__PURE__*/ function(ContentType) {
    ContentType["APPLICATION_CSV"] = "application/csv";
    ContentType["APPLICATION_JSON"] = "application/json";
    ContentType["APPLICATION_JSON_UTF_8"] = "application/json;charset=UTF-8";
    return ContentType;
}(ContentType || {});

var commonEnums = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccelerateProcessStatus: AccelerateProcessStatus,
  AmplifyCapabilities: AmplifyCapabilities,
  AmplifyErrorSources: AmplifyErrorSources,
  ArtifactTypes: ArtifactTypes,
  AuthToken: AuthToken,
  AuthenticationChannelEvents: AuthenticationChannelEvents,
  BenchMode: BenchMode,
  CapabilityAvailabilityReason: CapabilityAvailabilityReason,
  CaseAccessState: CaseAccessState,
  CaseAlertType: CaseAlertType,
  CaseArtifactTypes: CaseArtifactTypes,
  CaseConfigSection: CaseConfigSection,
  CaseDataGroup: CaseDataGroup,
  CaseDataTypes: CaseDataTypes,
  CaseDetailMode: CaseDetailMode,
  CaseStatus: CaseStatus,
  ChargeSessionCodeProvenance: ChargeSessionCodeProvenance,
  ChargeSessionCodeType: ChargeSessionCodeType,
  ChargeSessionProviderRole: ChargeSessionProviderRole,
  ChargeSessionType: ChargeSessionType,
  ChargeTypes: ChargeTypes,
  CodeAssessmentRiskCategory: CodeAssessmentRiskCategory,
  CodeChangeType: CodeChangeType,
  CodeSearchType: CodeSearchType,
  CodeType: CodeType,
  CodeTypes: CodeTypes,
  CoderNotesLookupType: CoderNotesLookupType,
  CoderNotesLookupTypeName: CoderNotesLookupTypeName,
  ConfigurationKeyName: ConfigurationKeyName,
  ConfigurationSection: ConfigurationSection,
  ContentTypes: ContentType,
  CrudOperations: CrudOperations,
  CursorOperation: CursorOperation,
  CustomerPhase: CustomerPhase,
  DateFilterLabelEnum: DateFilterLabelEnum,
  DictionaryEditStatus: DictionaryEditStatus,
  DictionaryFilterDefault: DictionaryFilterDefault,
  DictionaryRequestStatus: DictionaryRequestStatus,
  DictionaryStatus: DictionaryStatus,
  DocumentQueryType: DocumentQueryType,
  DocumentStatus: DocumentStatus,
  EditorIssueLevel: EditorIssueLevel,
  EditorIssueProvenance: EditorIssueProvenance,
  EntriesMessageType: EntriesMessageType,
  EvidenceType: EvidenceType,
  FeatureSources: FeatureSources,
  FeatureTypes: FeatureTypes,
  FeedbackMeta: FeedbackMeta,
  FieldType: FieldType,
  FilterKeys: FilterKeys,
  FilterTypes: FilterTypes,
  Gen2CaseStatus: Gen2CaseStatus,
  Gen2ProcessStatus: Gen2ProcessStatus,
  HoldReasonLabel: HoldReasonLabel,
  HoldReasonType: HoldReasonType,
  HttpMethods: Methods,
  IdentifierType: IdentifierType,
  IdentifierTypes: IdentifierTypes,
  ImprovementDictionaryProps: ImprovementDictionaryProps,
  InvoiceEditorMode: InvoiceEditorMode,
  InvoiceStatus: InvoiceStatus,
  InvoiceTypes: InvoiceTypes,
  IssueTypeErrors: IssueTypeErrors,
  LaunchParams: LaunchParams,
  MiniTabLabels: MiniTabLabels,
  ModifierTypes: ModifierTypes,
  NavigationAction: NavigationAction,
  ORGS: ORGS,
  OrgLevels: OrgLevels,
  PermissionLevel: PermissionLevel,
  ProcessInstanceActions: ProcessInstanceActions,
  ProcessQAStatus: ProcessQAStatus,
  ProcessRunType: ProcessRunType,
  ProcessStatus: ProcessStatus,
  ProcessStatusLabel: ProcessStatusLabel,
  Provenances: Provenances,
  ProviderType: ProviderType,
  RequiredField: RequiredField,
  ResourceId: ResourceId,
  ResourceTypes: ResourceTypes,
  ResponseStatus: ResponseStatus,
  ServiceLines: ServiceLines,
  SpanLevel: SpanLevel,
  SugggestedCodeType: SugggestedCodeType,
  SystemRole: SystemRole,
  TaskTypes: TaskTypes,
  TimelineStatus: TimelineStatus,
  TitleTabsEnum: TitleTabsEnum,
  UIModesEnum: UIModesEnum,
  UIViewEnum: UIViewEnum,
  UserPreferenceKey: UserPreferenceKey,
  UserPreferenceSection: UserPreferenceSection,
  uiStatus: uiStatus
});

export { CaseStatus as $, AmplifyErrorSources as A, BenchMode as B, CoderNotesLookupTypeName as C, DocumentQueryType as D, EditorIssueLevel as E, FeedbackMeta as F, ChargeSessionProviderRole as G, AuthToken as H, ImprovementDictionaryProps as I, ProviderType as J, UIViewEnum as K, SugggestedCodeType as L, Methods as M, InvoiceEditorMode as N, CoderNotesLookupType as O, ProcessQAStatus as P, ContentType as Q, ResourceId as R, ServiceLines as S, TimelineStatus as T, UIModesEnum as U, AmplifyCapabilities as V, ArtifactTypes as W, CaseConfigSection as X, CaseDataGroup as Y, CaseDataTypes as Z, CaseDetailMode as _, DocumentStatus as a, ChargeTypes as a0, CodeAssessmentRiskCategory as a1, CodeChangeType as a2, CodeTypes as a3, ConfigurationSection as a4, CrudOperations as a5, CursorOperation as a6, DateFilterLabelEnum as a7, DictionaryEditStatus as a8, DictionaryRequestStatus as a9, SystemRole as aA, TaskTypes as aB, TitleTabsEnum as aC, UserPreferenceKey as aD, UserPreferenceSection as aE, DictionaryStatus as aa, EntriesMessageType as ab, FieldType as ac, FilterKeys as ad, FilterTypes as ae, Gen2CaseStatus as af, Gen2ProcessStatus as ag, HoldReasonLabel as ah, HoldReasonType as ai, IdentifierType as aj, IdentifierTypes as ak, InvoiceStatus as al, LaunchParams as am, ModifierTypes as an, NavigationAction as ao, ORGS as ap, OrgLevels as aq, PermissionLevel as ar, ProcessInstanceActions as as, ProcessRunType as at, ProcessStatus as au, ProcessStatusLabel as av, Provenances as aw, RequiredField as ax, ResourceTypes as ay, ResponseStatus as az, ConfigurationKeyName as b, commonEnums$1 as c, InvoiceTypes as d, IssueTypeErrors as e, CaseArtifactTypes as f, EditorIssueProvenance as g, CaseAlertType as h, CodeType as i, CodeSearchType as j, ChargeSessionCodeType as k, CustomerPhase as l, DictionaryFilterDefault as m, AccelerateProcessStatus as n, CaseAccessState as o, MiniTabLabels as p, commonEnums as q, CapabilityAvailabilityReason as r, FeatureTypes as s, AuthenticationChannelEvents as t, uiStatus as u, FeatureSources as v, SpanLevel as w, EvidenceType as x, ChargeSessionCodeProvenance as y, ChargeSessionType as z };
//# sourceMappingURL=enums-BkyzwrG1.mjs.map
